/** @format */

import React, { useState, useEffect } from "react";
// import imglogo from "../../../assets/common/logo.webp";
import imglogo from "../../../assets/common/logo_sunny.webp";

import { Icon } from "@iconify/react";
import { useLocation, useNavigate } from "react-router-dom";
import { path } from "../../../utils/common/constant";
import flag_vi from "../../../assets/common/flag_vi.webp";
import flag_en from "../../../assets/common/flag_en.webp";
import { Dropdown } from "antd";
import MobileSidebar from "./MobileSidebar";
import "./style.css";
import { withTranslation, useTranslation } from "react-i18next";
const Header = ({ t }) => {
  // const [click, setClick] = useState(false);
  // const closeMenu = () => setClick(false);
  const location = useLocation();
  const navigate = useNavigate();

  const [locale, setLocale] = useState("vi");
  const { i18n } = useTranslation();
  const currentLanguage = localStorage.getItem("lang");
  const [sidebar, setSidebar] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleSidebar = () => {
    setSidebar(!sidebar);
  };

  const handleMenuClick = (e) => {
    if (e.key === "1") {
      setTimeout(
        () =>
          navigate("../" + path.common.SERVICES, {
            state: { targetId: "service_1" },
          }),
        0
      );
    } else if (e.key === "2") {
      setTimeout(
        () =>
          navigate("../" + path.common.STRATEGY_SERVICE, {
            state: { targetId: "service_2" },
          }),
        0
      );
    } else {
      setTimeout(
        () =>
          navigate("../" + path.common.MANAGEMENT_SERVICE, {
            state: { targetId: "service_3" },
          }),
        0
      );
    }
  };

  const items = [
    {
      key: "1",
      label: (
        <div className="w-full p-2  text-primary cursor-pointer hover:text-secondary1">
          <p className={` ${sidebar ? "text-xl " : "text-sm "}`}>
            {t("HeaderService_1")}
          </p>
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <div className="w-full p-2  text-primary cursor-pointer hover:text-secondary1">
          <p className={`${sidebar ? "text-xl" : "text-sm "}`}>
            {t("HeaderService_2")}
          </p>
        </div>
      ),
    },
    {
      key: "3",
      label: (
        <div className="w-full p-2  text-primary cursor-pointer hover:text-secondary1">
          <p className={`${sidebar ? "text-xl" : "text-sm "}`}>
            {t("HeaderService_3")}
          </p>
        </div>
      ),
    },
  ];

  // watch location pathname to set active index
  useEffect(() => {
    const path = location.pathname.split("/")[1];
    switch (path) {
      case "":
        setActiveIndex(0);
        break;
      case "about":
        setActiveIndex(1);
        break;
      case "service":
        setActiveIndex(2);
        break;
      case "strategy-service":
        setActiveIndex(2);
        break;
      case "management-service":
        setActiveIndex(2);
        break;
      case "blog":
        setActiveIndex(3);
        break;

      case "career":
        setActiveIndex(4);
        break;
      case "partners":
        setActiveIndex(5);
        break;
      case "contact":
        setActiveIndex(6);
        break;
      case "soko":
        setActiveIndex(7);
        break;
      default:
        setActiveIndex(0);
    }
  }, [location.pathname]);

  const changeLocale = () => {
    if (locale === "en") {
      setLocale("vi");
      i18n.changeLanguage(locale);
    } else {
      setLocale("en");
      i18n.changeLanguage(locale);
    }
  };

  return (
    <div className="py-[1rem] px-[40px] bg-white ">
      <nav className="flex ">
        <div
          className=" flex items-center "
          onClick={() => {
            navigate("../" + path.common.HOME);
            if (sidebar) toggleSidebar();
          }}
        >
          <img
            alt={imglogo}
            src={imglogo}
            className={"h-[100px]  cursor-pointer object-cover"}
          ></img>
        </div>
        <div className={"flex flex-1 justify-end items-center"}>
          <div className="text-right flex flex-wrap ">
            <ul className="hidden lg:flex text-base  gap-3 text-center  items-center md:max-lg:text-[16px]  sticky top-0 pv:max-md:hidden uppercase ">
              {[
                { name: t("HeaderHome"), path: path.common.HOME },
                { name: t("HeaderAbout"), path: path.common.ABOUT },
                {
                  name: t("HeaderService"),
                  path: path.common.SERVICES,
                  dropdown: true,
                },

                // { name: t("HeaderBlog"), path: path.common.BLOG },
                { name: t("HeaderCSR"), path: path.common.BLOG }, // Update 12/10/2025: Change BLOG to SOKO and add SOKO content in blog page.
                { name: t("HeaderCareer"), path: path.common.CAREER },
                { name: t("HeaderPartners"), path: path.common.PARTNERS },
                { name: t("HeaderContact"), path: path.common.CONTACT },
                // { name: t("HeaderSoko"), path: path.common.SOKO },
              ].map((item, index) => (
                <li
                  key={index}
                  className={`py-[1rem] relative cursor-pointer text-primary hover:text-secondary1 ${
                    activeIndex === index
                      ? "underline decoration-primary underline-offset-8 decoration-2"
                      : ""
                  }`}
                  onClick={() => {
                    navigate("../" + item.path);
                  }}
                  style={{ fontWeight: 500 }}
                >
                  {item.dropdown ? (
                    <Dropdown
                      menu={{
                        items,
                        onClick(e) {
                          handleMenuClick(e);
                        },
                      }}
                      placement="bottom"
                    >
                      <a
                        className="flex justify-center items-center mx-[1rem]"
                        style={{ lineHeight: 1.2, fontWeight: 500 }}
                      >
                        <span className={"text-[1rem]"}>{item.name}</span>
                        <Icon className="h-4 w-4" icon={"mingcute:down-line"} />
                      </a>
                    </Dropdown>
                  ) : (
                    <span
                      className="text-[1rem] mx-[1rem]"
                      style={{ fontWeight: 500 }}
                    >
                      {item.name}
                    </span>
                  )}
                </li>
              ))}
            </ul>
          </div>

          <div
            className={`flex ml-[2rem] pv:max-lg:pb-0 pv:max-ph:pr-4 cursor-pointer pv:max-lg:ml-0 ${
              sidebar ? "hidden" : ""
            }`}
          >
            <img
              src={locale === "vi" ? flag_vi : flag_en}
              alt="Change language"
              className="h-6 w-9 object-cover "
              onClick={changeLocale}
            />
          </div>
        </div>

        <MobileSidebar
          sidebar={sidebar}
          toggleSidebar={toggleSidebar}
          activeIndex={activeIndex}
          navigate={navigate}
          handleMenuClick={handleMenuClick}
          items={items}
          locale={locale}
          changeLocale={changeLocale}
          flag_vi={flag_vi}
          flag_en={flag_en}
        />
      </nav>
    </div>
  );
};

export default withTranslation()(Header);
